import axios from 'axios';
import serviceUtil from './serviceUtil';

export default {
  countMyTasks(user) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/tasks/count_my_tasks?current_company=' + localStorage.current_company_id +
        '&user_id=' + user.id,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => { 
        return serviceUtil.resultForError(error);
      });
  },
  getTaskMetrics() {
    let timeZone = null;
    try {
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      // send timezone as null if user on a very old browser
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API 
        + '/analytics/task_metrics?current_company=' + localStorage.current_company_id 
        +'&user_id=' + localStorage.loggedin_user_id
        + '&timezone=' + timeZone,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => { 
        return serviceUtil.resultForError(error);
      });
  },
  
};



// WEBPACK FOOTER //
// ./src/services/analyticsService.js